<template>
  <h2>Redirecting to Login ...</h2>
</template>

<script>
export default {
  mounted: function () {
    //window.location.href="/"
  },
};
</script>

<style>
</style> 